import { render, staticRenderFns } from "./PrescribedMedicationView.vue?vue&type=template&id=ea7873a4&scoped=true&"
import script from "./PrescribedMedicationView.vue?vue&type=script&lang=ts&"
export * from "./PrescribedMedicationView.vue?vue&type=script&lang=ts&"
import style0 from "./PrescribedMedicationView.vue?vue&type=style&index=0&id=ea7873a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7873a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTooltip})
